import { PairingMethods, PairingValidationStatus } from '../../../constants/Constants';
import { dateHeader, formatCellDate } from '../../../utils/columns/timeModeCell';
import { authorizedLinkTo } from '../../../utils/linkTo';
import { AppPermissions } from '../../../constants/Permissions';

const makePairingHistoryColumn = () => {
  return [
    {
      header: 'Device',
      accessorKey: 'deviceId',
      sortable: false,
      enableColumnFilter: true,
      size: 150,
      cell: ({ row }) => authorizedLinkTo(AppPermissions.Device.Read, `/devices/${row.original.deviceId}`, row.original.deviceId),
    },
    {
      header: 'Equipment',
      accessorKey: 'serialNumber',
      sortable: false,
      enableColumnFilter: true,
      size: 120,
      cell: ({ row }) => authorizedLinkTo(AppPermissions.Equipment.Read, `/equipment/${row.original.equipmentId}`, row.original.serialNumber),
    },
    {
      header: 'Paired by',
      accessorKey: 'pairedUserName',
      sortable: false,
      enableColumnFilter: true,
      size: 150,
    },
    {
      header: dateHeader('Paired time'),
      accessorKey: 'pairedDateTime',
      enableColumnFilter: false,
      size: 120,
      cell: ({ row, table }) => formatCellDate(table, row.original.pairedDateTime),
    },
    {
      header: 'Station',
      accessorKey: 'stationIataCode',
      sortable: true,
      enableColumnFilter: true,
      size: 150,
    },
    {
      header: 'Facility',
      accessorKey: 'facilityName',
      sortable: true,
      enableColumnFilter: false,
      size: 150,
    },
    {
      header: 'Method',
      accessorKey: 'pairingMethod',
      enableColumnFilter: false,
      size: 100,
      cell: ({ row }) => PairingMethods[row.original.pairingMethod ?? 0],
    },
    {
      header: 'Status',
      accessorKey: 'equipmentPairingStatus',
      sortable: false,
      enableColumnFilter: false,
      size: 80,
      cell: ({ row }) => (row.original.equipmentPairingStatus == 1 ? 'Paired' : 'Unpaired'),
    },
    {
      header: 'Validation',
      accessorKey: 'pairingValidationStatus',
      sortable: false,
      enableColumnFilter: false,
      size: 120,
      cell: ({ row }) => PairingValidationStatus[row.original.pairingValidationStatus],
    },
    {
      header: 'Imei',
      accessorKey: 'imei',
      sortable: false,
      enableColumnFilter: true,
      size: 120,
    },
    {
      header: 'Unpaired by',
      accessorKey: 'unpairedUserName',
      sortable: false,
      enableColumnFilter: true,
      size: 150,
    },
    {
      header: dateHeader('Unpaired'),
      accessorKey: 'unPairedDateTime',
      enableColumnFilter: false,
      size: 120,
      cell: ({ row, table }) => formatCellDate(table, row.original.unpairedDateTime),
    },
  ] as Array<any>;
};

export default makePairingHistoryColumn;
